import useCostEstimate from "./useCostEstimate"
import CostEstimateStatus from "./CostEstimateStatus"
import ModalWhatsAppQRCode from "../../components/Modal/ModalWhatsAppQRCode"
import React, { useEffect, useState } from "react"
import styles from "./whatsAppIntegration.module.css"
import api from '../../services/api'
import { toast } from 'react-toastify'
import { useParams } from "react-router-dom"
import Loading from '../layouts/Loading'
import Button from '../../components/Form/Button'
import BackButton from './../../components/BackButton/index';
import { MdOutlineSync, MdOutlineWhatsapp } from "react-icons/md"
import { MdHistory, MdOpenInNew } from "react-icons/md"
import FormGroup from '../../components/Form/FormGroup'
import Input from "../../components/Form/Input"
import Select from "../../components/Form/Select"
import DatePicker from "../../components/Form/DatePicker"
import Modal from "../../components/Modal"
import ModalInbox from "../../components/Modal/ModalInbox"
import ModalWhatsAppLiteConnection from "../../components/Modal/ModalInbox/ModalWhatsAppLiteConnection"
import ModalNewInbox from "../../components/Modal/ModalInbox/ModalNewInbox"
import ModalConfirm from "../../components/Modal/ModalConfirm"
import { useWebSocketChatContext } from "../../contexts/webSocketChatContext"
import { useData } from "../../contexts/dataContext"
import { maskPhone } from "../../utils/formatter"
import { AiOutlineDisconnect } from "react-icons/ai"
import InboxCard from "../../components/InboxCard"
import { useAuth } from "../../contexts/authContext"
import InfoTooltip from "../../components/InfoTooltip"

const WHATSAPP_API_PRICING_URL = "https://whatsappbusiness.com/pt-br/products/platform-pricing/?country=Brazil&currency=Dollar%20(USD)&category=Authentication#taxas-de-mensagens"
const FALLBACK_USD_TO_BRL_ESTIMATE = 5.50

const WHATSAPP_API_RATES_USD = {
    marketing: 0.0625,
    utility: 0.0068,
    authentication: 0.0068,
    service: 0,
}

const TEMPLATE_CATEGORIES = [
    { id: "marketing", value: "Marketing" },
    { id: "utility", value: "Utilidade" },
    { id: "authentication", value: "Autenticação" },
]

const formatNumber = (value = 0) => Number(value || 0).toLocaleString("pt-BR")
const formatMoney = (value = 0) => Number(value || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
const formatUsd = (value = 0) => Number(value || 0).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 4, maximumFractionDigits: 4 })
const toNumber = (value = 0) => Number(`${value}`.replace(",", ".")) || 0
const clampPercent = (value = 0) => Math.max(0, Math.min(100, toNumber(value)))
const getRateBrl = (category, usdToBrl = FALLBACK_USD_TO_BRL_ESTIMATE) => (WHATSAPP_API_RATES_USD[category] || 0) * usdToBrl
const formatDateTime = (date) => date ? new Date(date).toLocaleString("pt-BR") : "-"

const ASSIGNMENT_SOURCE_OPTIONS = [
    { id: "new_conversation", value: "Nova conversa" },
    { id: "manual", value: "Manual" },
    { id: "management", value: "Gestão em massa" },
    { id: "bulk_action", value: "Ação em lote" },
    { id: "ai_handoff", value: "IA para humano" },
    { id: "access_request", value: "Liberação de acesso" },
    { id: "chat_start", value: "Início de atendimento" },
]

const ASSIGNMENT_SOURCE_TOOLTIP = "Nova conversa é a atribuição aplicada na chegada do atendimento. Manual é feita por uma pessoa no chat. Gestão em massa usa filtros para alterar conversas. Ação em lote usa conversas selecionadas manualmente. IA para humano ocorre em transferência do agente. Liberação de acesso registra aprovações de acesso. Início de atendimento registra quando alguém assume ao abrir."

const getDefaultAssignmentFilters = () => ({ dateStart: "", dateEnd: "", sources: [] })

const WhatsAppIntegration = () => {
    const [qrInbox, setQrInbox] = useState(null)
    const [inbox, setInbox] = useState({})
    const [whatsAppInboxes, setWhatsAppInboxes] = useState([])
    const [showModalInbox, setShowModalInbox] = useState(false)
    const [showModalLiteConnection, setShowModalLiteConnection] = useState(false)
    const [liteConnectionInbox, setLiteConnectionInbox] = useState({})
    const [showModalNewInbox, setShowModalNewInbox] = useState(false)
    const [inboxDisconect, setInboxDisconect] = useState({})
    const [ChatInboxSync, setInboxSync] = useState({})
    const [showModalDisconect, setShowModalDisconect] = useState(false)
    const [showModalSyncMessages, setShowModalSyncMessages] = useState(false)
    const [showModalSyncContacts, setShowModalSyncContacts] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [showCostEstimateModal, setShowCostEstimateModal] = useState(false)
    const [showWhatsAppApiInfoModal, setShowWhatsAppApiInfoModal] = useState(false)
    const [showAssignmentHistoryModal, setShowAssignmentHistoryModal] = useState(false)
    const [assignmentHistoryInbox, setAssignmentHistoryInbox] = useState({})
    const [assignmentHistory, setAssignmentHistory] = useState({ assignments: [], pagination: {} })
    const [assignmentHistoryFilters, setAssignmentHistoryFilters] = useState(getDefaultAssignmentFilters())
    const [isLoadingAssignmentHistory, setIsLoadingAssignmentHistory] = useState(false)
    const [users, setUsers] = useState([])
    const [chatBots, setChatBots] = useState([])
    const [selectedInboxIds, setSelectedInboxIds] = useState([])
    const [selectedPeriod, setSelectedPeriod] = useState(30)
    const [templateMix, setTemplateMix] = useState({ marketing: 80, utility: 20, authentication: 0 })
    const [campaignSimulation, setCampaignSimulation] = useState({
        marketing: { contacts: 0, campaigns: 0 },
        utility: { contacts: 0, campaigns: 0 },
        authentication: { contacts: 0, campaigns: 0 },
    })
    const [, setSyncClock] = useState(Date.now())

    const { teams, roles, allUsersGroup, funnels, loadFunnels } = useData()
    const { permissions } = useAuth()
    const { lastJsonMessage, sendJsonMessage } = useWebSocketChatContext()
    const { account_id } = useParams()
    const { costEstimate, isLoadingEstimate, estimateError, estimateProgress, refreshEstimate } = useCostEstimate(showCostEstimateModal, account_id)
    const canAddWhatsAppInbox = permissions?.whatsapp_inboxes >= 2

    useEffect(() => {
        updateDataByMessageWebSocket(lastJsonMessage)
    }, [lastJsonMessage])

    useEffect(() => {
        getAllWhatsAppInboxes()
        getAllChatBots()
        loadFunnels()
    }, [])

    useEffect(() => {
        setUsers(allUsersGroup?.map(user => ({ id: user?._id, value: user?.name, teams: user?.teams?.map(team => team?.team_id || team) || [] })))
    }, [allUsersGroup])

    useEffect(() => {
        if (!costEstimate) return
        const inboxIds = costEstimate?.inboxes?.map(inbox => inbox?._id?.toString()).filter(Boolean) || []
        setSelectedInboxIds(previousValue => previousValue.length ? previousValue.filter(inboxId => inboxIds.includes(inboxId)) : inboxIds)
    }, [costEstimate])

    useEffect(() => {
        const hasRunningSync = whatsAppInboxes.some(inbox => inbox?.sync?.status === "running")
        if (!hasRunningSync) return

        const timer = setInterval(() => {
            setSyncClock(Date.now())
        }, 1000)

        return () => clearInterval(timer)
    }, [whatsAppInboxes])

    const updateDataByMessageWebSocket = (message) => {
        const event = message?.event
        const content = message?.content

        switch (event) {
            case "UPDATE_INBOX":
                updateInboxByContent(content)
                break
            case "SYNC_STARTED":
                updateInboxSync(content)
                break
            case "SYNC_PROGRESS":
                updateInboxSync(content)
                break
            case "SYNC_COMPLETED":
                updateInboxSync(content)
                toast.success("Sincronização concluída com sucesso!")
                break
            case "SYNC_ERROR":
                updateInboxSync(content)
                toast.error(content?.error || "Erro na sincronização")
                break
            case "NOTIFICATION":
                if (content?.message) {
                    toast.success(content.message)
                }
                break
            case "ERROR":
                if (content?.error) {
                    toast.error(content.error)
                }
                break
            default:
                break
        }
    }

    const updateInboxByContent = (newContent) => {
        const inbox_id = newContent?._id
        if (inbox_id) {
            setWhatsAppInboxes(previousValue => {
                if (previousValue.find(inbox => inbox?._id === inbox_id)) {
                    return previousValue.map(inbox => {
                        if (inbox?._id === inbox_id) {
                            return { ...inbox, ...newContent }
                        }
                        return inbox
                    })
                }
                return previousValue
            })
            if (inbox?._id === inbox_id) {
                setInbox(previousValue => ({ ...previousValue, ...newContent }))
            }
            if (liteConnectionInbox?._id === inbox_id) {
                setLiteConnectionInbox(previousValue => ({ ...previousValue, ...newContent }))
            }
        }
    }

    const updateInboxSync = (content) => {
        const { inbox_id, sync } = content
        if (!inbox_id || !sync) return

        setWhatsAppInboxes(prev =>
            prev.map(inbox =>
                inbox._id === inbox_id
                    ? { ...inbox, sync }
                    : inbox
            )
        )
    }

    const getAllWhatsAppInboxes = () => {
        setIsLoading(true)
        api.get("/integrations/whatsapp/inboxes").then(response => {
            const Inboxes = response?.data?.data || []
            setWhatsAppInboxes(Inboxes)
        }).catch(err => toast.error(err?.response?.data?.message))
            .finally(() => setIsLoading(false))
    }

    const getQRCodeByConnect = (inboxId) => {
        setIsLoading(true)
        api.get(`/integrations/whatsapp/inboxes/${inboxId}/connect`).then(response => {
            const data = response?.data?.data || []
            if (data?.qrCode?.base64) {
                const expires_in = data?.qrCode?.expires_in || 30000
                setTimeout(() => {
                    setInbox(previousValue => ({ ...previousValue, qrCode: { ...previousValue.qrCode, expired: true } }))
                    setLiteConnectionInbox(previousValue => previousValue?._id === inboxId ? ({ ...previousValue, qrCode: { ...previousValue.qrCode, expired: true } }) : previousValue)
                }, expires_in)
            }
            setInbox(previousValue => ({ ...previousValue, ...data }))
            setLiteConnectionInbox(previousValue => previousValue?._id === inboxId ? ({ ...previousValue, ...data }) : previousValue)
        }).catch(err => toast.error(err?.response?.data?.message))
            .finally(() => setIsLoading(false))
    }

    const getAllChatBots = () => {
        setIsLoading(true)
        api.get("/integrations/whatsapp/chatbots").then(response => {
            const data = response?.data?.data || []
            setChatBots(data)
        }).catch(err => toast.error(err?.response?.data?.message))
            .finally(() => setIsLoading(false))
    }

    const getOfficialApiCostEstimate = refreshEstimate
    const handleShowCostEstimateModal = () => setShowCostEstimateModal(true)

    const handleSaveNewInbox = (data) => {
        setIsLoading(true)
        api.post("/integrations/whatsapp/inboxes", data).then(response => {
            const inbox = response.data.data
            addNewInbox(inbox)
            handleCloseModalNewInbox()
        }).catch(err => toast.error(err?.response?.data?.message))
            .finally(() => setIsLoading(false))
    }

    const handleUpdateInbox = (data) => {
        setIsLoading(true)
        api.patch(`/integrations/whatsapp/inboxes/${data?._id}`, data).then(response => {
            const inbox = response.data.data
            updateInboxByContent(inbox)
            handleCloseModalInbox()
        }).catch(err => toast.error(err?.response?.data?.message))
            .finally(() => setIsLoading(false))
    }

    const addNewInbox = (inbox) => {
        setWhatsAppInboxes(previousValue => ([...previousValue, inbox]))
    }

    const handleShowModalNewInbox = () => {
        setShowModalNewInbox(true)
    }

    const handleCloseModalNewInbox = () => {
        setShowModalNewInbox(false)
    }

    const handleShowModalInbox = (inboxId) => {
        setIsLoading(true)
        api.get(`/integrations/whatsapp/inboxes/${inboxId}`).then(response => {
            const inbox = response?.data?.data || {}
            setInbox(inbox)
            setShowModalInbox(true)
        }).catch(err => toast.error(err?.response?.data?.message))
            .finally(() => setIsLoading(false))
    }

    const handleCloseModalInbox = () => {
        setShowModalInbox(false)
    }

    const handleShowModalLiteConnection = (inbox) => {
        setLiteConnectionInbox(inbox)
        setShowModalLiteConnection(true)
    }

    const handleCloseModalLiteConnection = () => {
        setShowModalLiteConnection(false)
        setLiteConnectionInbox({})
    }

    const sortWhatsAppInboxs = (a, b) => {
        if (a.name > b.name) {
            return 1
        } else if (a.name < b.name) {
            return -1
        } else {
            return 0
        }
    }

    const handleShowModalDisconect = (inbox) => {
        setInboxDisconect(inbox)
        setShowModalDisconect(true)
    }

    const handleCloseModalDisconect = () => {
        setInboxDisconect({})
        setShowModalDisconect(false)
    }

    const handleDisconectInbox = (inbox) => {
        setIsLoading(true)
        api.post(`/integrations/whatsapp/inboxes/${inbox._id}/disconnect`).then(response => {
            handleCloseModalDisconect()
            toast.success(response?.data?.message)
        }).catch(err => {
            toast.error(err?.response?.data?.message)
        }).finally(() => setIsLoading(false))
    }

    const handleShowModalSyncMessages = (inbox) => {
        setInboxSync(inbox)
        setShowModalSyncMessages(true)
    }

    const handleShowModalSyncContacts = (inbox) => {
        setInboxSync(inbox)
        setShowModalSyncContacts(true)
    }

    const handleCloseModalSyncMessages = () => {
        setInboxSync({})
        setShowModalSyncMessages(false)
    }

    const handleCloseModalSyncContacts = () => {
        setInboxSync({})
        setShowModalSyncContacts(false)
    }

    const getAssignmentHistory = (inboxId = assignmentHistoryInbox?._id, filters = assignmentHistoryFilters, page = 1) => {
        if (!inboxId) return

        setIsLoadingAssignmentHistory(true)
        api.get(`/integrations/whatsapp/inboxes/${inboxId}/assignment-history`, {
            params: {
                ...(filters.dateStart ? { dateStart: filters.dateStart } : {}),
                ...(filters.dateEnd ? { dateEnd: filters.dateEnd } : {}),
                ...(filters.sources?.length ? { sources: filters.sources.join(",") } : {}),
                page,
                limit: 50,
            }
        }).then(response => {
            const data = response?.data?.data || { assignments: [], pagination: {} }
            setAssignmentHistory(previousValue => ({
                assignments: page > 1 ? [...(previousValue?.assignments || []), ...(data.assignments || [])] : data.assignments || [],
                pagination: data.pagination || {}
            }))
        }).catch(err => toast.error(err?.response?.data?.message))
            .finally(() => setIsLoadingAssignmentHistory(false))
    }

    const handleShowAssignmentHistory = (inbox) => {
        const filters = getDefaultAssignmentFilters()
        setAssignmentHistoryInbox(inbox)
        setAssignmentHistoryFilters(filters)
        setShowAssignmentHistoryModal(true)
        getAssignmentHistory(inbox?._id, filters)
    }

    const handleCloseAssignmentHistory = () => {
        setShowAssignmentHistoryModal(false)
        setAssignmentHistoryInbox({})
        setAssignmentHistory({ assignments: [], pagination: {} })
    }

    const handleAssignmentHistoryPeriodChange = (dateStart, dateEnd) => {
        setAssignmentHistoryFilters(previousValue => ({ ...previousValue, dateStart: dateStart || "", dateEnd: dateEnd || "" }))
    }

    const handleAssignmentHistorySourceChange = (sources) => {
        setAssignmentHistoryFilters(previousValue => ({ ...previousValue, sources: sources || [] }))
    }

    const handleLoadMoreAssignmentHistory = () => {
        const nextPage = Number(assignmentHistory?.pagination?.page || 1) + 1
        getAssignmentHistory(assignmentHistoryInbox?._id, assignmentHistoryFilters, nextPage)
    }

    const handleSyncAllMessages = (inbox) => {
        sendJsonMessage({ event: "SYNC_ALL_MESSAGES", message: { inbox_id: inbox._id } })
        handleCloseModalSyncMessages()
    }

    const handleSyncAllContacts = (inbox) => {
        sendJsonMessage({ event: "SYNC_ALL_CONTACTS", message: { inbox_id: inbox._id } })
        handleCloseModalSyncContacts()
    }

    const getElapsedTime = (sync) => {
        if (!sync?.started_at) return null

        const diff = Date.now() - new Date(sync.started_at).getTime()

        const minutes = Math.floor(diff / 60000)
        const seconds = Math.floor((diff % 60000) / 1000)

        return `${minutes}:${seconds.toString().padStart(2, "0")}`
    }

    const getSyncSpeed = (sync) => {
        const referenceDate = sync?.processing_started_at || sync?.started_at
        if (!referenceDate || !sync?.processed) return null

        const elapsedSeconds =
            (Date.now() - new Date(referenceDate).getTime()) / 1000

        if (elapsedSeconds <= 0) return null

        const speed = sync.processed / elapsedSeconds

        return speed.toFixed(1)
    }

    const getEstimatedTime = (sync) => {
        const referenceDate = sync?.processing_started_at || sync?.started_at
        if (!referenceDate || !sync?.processed || !sync?.total) return null

        const elapsedSeconds = (Date.now() - new Date(referenceDate).getTime()) / 1000

        if (elapsedSeconds <= 0) return null

        const speed = sync.processed / elapsedSeconds

        if (speed <= 0) return null

        const remaining = Math.max((sync.total || 0) - (sync.processed || 0), 0)

        const remainingSeconds = remaining / speed

        const minutes = Math.floor(remainingSeconds / 60)
        const seconds = Math.floor(remainingSeconds % 60)

        return `${minutes}m ${seconds}s`
    }

    const getProgressPercent = (sync) => {
        const processed = sync?.processed || 0
        const total = sync?.total || 0

        if (total === 0) return 0

        return Math.floor((processed / total) * 100)
    }

    const getEmptyPeriodStats = () => ({
        period_days: selectedPeriod,
        total_messages: 0,
        sent_messages: 0,
        received_messages: 0,
        sent_inside_24h_window: 0,
        sent_outside_24h_window: 0,
        campaign_sent_messages: 0,
        unique_contacts: 0,
        conversations: 0,
    })

    const sumPeriodStats = (statsList = []) => {
        return statsList.reduce((total, stats) => ({
            period_days: selectedPeriod,
            total_messages: total.total_messages + (stats?.total_messages || 0),
            sent_messages: total.sent_messages + (stats?.sent_messages || 0),
            received_messages: total.received_messages + (stats?.received_messages || 0),
            sent_inside_24h_window: total.sent_inside_24h_window + (stats?.sent_inside_24h_window || 0),
            sent_outside_24h_window: total.sent_outside_24h_window + (stats?.sent_outside_24h_window || 0),
            campaign_sent_messages: total.campaign_sent_messages + (stats?.campaign_sent_messages || 0),
            unique_contacts: total.unique_contacts + (stats?.unique_contacts || 0),
            conversations: total.conversations + (stats?.conversations || 0),
        }), getEmptyPeriodStats())
    }

    const getPeriodStatsFromInbox = (inbox) => {
        return inbox?.periods?.find(period => Number(period.period_days) === Number(selectedPeriod)) || getEmptyPeriodStats()
    }

    const getSelectedInboxes = () => {
        const inboxes = costEstimate?.inboxes || []

        return inboxes.filter(inbox => selectedInboxIds.includes(inbox?._id?.toString()))
    }

    const getSelectedPeriodStats = () => {
        const selectedInboxes = getSelectedInboxes()
        if (selectedInboxes.length) {
            return sumPeriodStats(selectedInboxes.map(inbox => getPeriodStatsFromInbox(inbox)))
        }

        return getEmptyPeriodStats()
    }

    const getTemplateMixTotal = () => {
        return Object.values(templateMix).reduce((total, value) => total + clampPercent(value), 0)
    }

    const getTemplateShare = (category) => {
        return clampPercent(templateMix[category]) / 100
    }

    const getHistoricalCostProjection = () => {
        const stats = getSelectedPeriodStats()
        const monthlyFactor = 30 / Number(selectedPeriod || 30)
        const paidMessages = Math.round((stats?.sent_outside_24h_window || 0) * monthlyFactor)
        const messagesByCategory = {
            marketing: Math.round(paidMessages * getTemplateShare("marketing")),
            utility: Math.round(paidMessages * getTemplateShare("utility")),
            authentication: Math.round(paidMessages * getTemplateShare("authentication")),
        }
        const costByCategory = {
            marketing: messagesByCategory.marketing * getRateBrl("marketing", usdToBrlEstimate),
            utility: messagesByCategory.utility * getRateBrl("utility", usdToBrlEstimate),
            authentication: messagesByCategory.authentication * getRateBrl("authentication", usdToBrlEstimate),
        }
        const total = Object.values(costByCategory).reduce((sum, value) => sum + value, 0)

        return { paidMessages, monthlyFactor, messagesByCategory, costByCategory, total }
    }

    const getCampaignProjection = () => {
        const byCategory = TEMPLATE_CATEGORIES.map(category => {
            const simulation = campaignSimulation[category.id] || {}
            const contacts = Math.max(0, toNumber(simulation.contacts))
            const campaigns = Math.max(0, toNumber(simulation.campaigns))
            const messages = contacts * campaigns
            const rateUsd = WHATSAPP_API_RATES_USD[category.id] || 0
            const rate = getRateBrl(category.id, usdToBrlEstimate)

            return {
                category: category.id,
                label: category.value,
                contacts,
                campaigns,
                messages,
                rateUsd,
                rate,
                total: messages * rate,
            }
        })

        return {
            byCategory,
            messages: byCategory.reduce((total, item) => total + item.messages, 0),
            total: byCategory.reduce((total, item) => total + item.total, 0),
        }
    }

    const handleTemplateMixChange = (category, value) => {
        const nextValue = Math.round(clampPercent(value))
        const otherCategories = TEMPLATE_CATEGORIES.map(item => item.id).filter(id => id !== category)

        setTemplateMix(previousValue => {
            const remaining = 100 - nextValue
            const otherTotal = otherCategories.reduce((total, id) => total + clampPercent(previousValue[id]), 0)
            const nextMix = { ...previousValue, [category]: nextValue }

            if (otherTotal <= 0) {
                const firstValue = Math.floor(remaining / otherCategories.length)
                otherCategories.forEach((id, index) => {
                    nextMix[id] = index === otherCategories.length - 1 ? remaining - firstValue : firstValue
                })
            } else {
                let used = 0
                otherCategories.forEach((id, index) => {
                    const calculated = index === otherCategories.length - 1
                        ? remaining - used
                        : Math.round((clampPercent(previousValue[id]) / otherTotal) * remaining)
                    nextMix[id] = calculated
                    used += calculated
                })
            }

            return nextMix
        })
    }

    const applyTemplateMixPreset = (preset) => {
        const presets = {
            balanced: { marketing: 50, utility: 50, authentication: 0 },
            marketing: { marketing: 80, utility: 20, authentication: 0 },
            utility: { marketing: 20, utility: 80, authentication: 0 },
            service: { marketing: 35, utility: 65, authentication: 0 },
            lowMarketing: { marketing: 10, utility: 90, authentication: 0 },
            authentication: { marketing: 20, utility: 40, authentication: 40 },
        }

        setTemplateMix(presets[preset] || presets.balanced)
    }

    const getActiveTemplateMixPreset = () => {
        const presets = {
            balanced: { marketing: 50, utility: 50, authentication: 0 },
            marketing: { marketing: 80, utility: 20, authentication: 0 },
            utility: { marketing: 20, utility: 80, authentication: 0 },
            service: { marketing: 35, utility: 65, authentication: 0 },
            lowMarketing: { marketing: 10, utility: 90, authentication: 0 },
            authentication: { marketing: 20, utility: 40, authentication: 40 },
        }

        return Object.entries(presets).find(([, preset]) =>
            TEMPLATE_CATEGORIES.every(category => Number(templateMix[category.id]) === Number(preset[category.id]))
        )?.[0]
    }

    const handleCampaignSimulationChange = (category, field, value) => {
        setCampaignSimulation(previousValue => ({
            ...previousValue,
            [category]: {
                ...previousValue[category],
                [field]: Math.max(0, toNumber(value)),
            }
        }))
    }

    const getAverageTemplateRate = () => {
        return TEMPLATE_CATEGORIES.reduce((total, category) => total + (getRateBrl(category.id, usdToBrlEstimate) * getTemplateShare(category.id)), 0)
    }

    const getAverageTemplateRateUsd = () => {
        return TEMPLATE_CATEGORIES.reduce((total, category) => total + ((WHATSAPP_API_RATES_USD[category.id] || 0) * getTemplateShare(category.id)), 0)
    }

    const getInboxHistoricalProjection = (inbox) => {
        const stats = getPeriodStatsFromInbox(inbox)
        const monthlyFactor = 30 / Number(selectedPeriod || 30)
        const paidMessages = Math.round((stats?.sent_outside_24h_window || 0) * monthlyFactor)
        const total = TEMPLATE_CATEGORIES.reduce((sum, category) => {
            return sum + (paidMessages * getTemplateShare(category.id) * getRateBrl(category.id, usdToBrlEstimate))
        }, 0)

        return { paidMessages, total }
    }

    const getAssignmentSourceLabel = (source) => {
        const labels = {
            new_conversation: "Nova conversa",
            manual: "Manual",
            ai_handoff: "IA para humano",
            management: "Gestão em massa",
            bulk_action: "Ação em lote",
            access_request: "Liberação de acesso",
            chat_start: "Início de atendimento",
        }

        return labels[source] || "Atribuição"
    }

    const getAssignmentRuleLabel = (assignment) => {
        const rule = assignment?.assignment_rule
        const owner = assignment?.owner

        if (rule?.users?.includes("auto") && rule?.round_robin?.mode === "custom") return "Rodízio personalizado"
        if (rule?.users?.includes("auto") || assignment?.round_robin_selected_user_id) return "Rodízio automático"
        if (rule?.assign_to === "teamAndRole" || owner?.assignTo === "teamAndRole") return "Equipe/Cargo"
        if (rule?.users?.length || owner?.assignTo === "users") return "Usuário(s)"

        return "Regra não registrada"
    }

    const getAssignmentReasonLabel = (assignment) => {
        const context = assignment?.assignment_context
        const reasons = {
            lead_owner_match: "Responsável do lead correspondente",
            inbox_default_rule: "Regra padrão da caixa",
        }

        if (context?.reason_label) return context.reason_label
        if (context?.reason && reasons[context.reason]) return reasons[context.reason]
        if (assignment?.source === "new_conversation") return `Regra padrão: ${getAssignmentRuleLabel(assignment)}`
        if (assignment?.source === "manual") return "Atribuição manual"
        if (assignment?.source === "management") return "Alteração em massa"
        if (assignment?.source === "bulk_action") return "Ação em lote"
        if (assignment?.source === "ai_handoff") return "Transferência da IA"
        if (assignment?.source === "access_request") return "Solicitação aprovada"
        if (assignment?.source === "chat_start") return "Usuário assumiu o atendimento"

        return getAssignmentRuleLabel(assignment)
    }

    const getAssignmentTargetLabel = (assignment) => {
        const users = assignment?.assigned_users?.map(user => user.name).filter(Boolean) || []
        const team = assignment?.team?.name
        const role = assignment?.role?.name

        if (users.length) return users.join(", ")
        if (team && role) return `${team} / ${role}`
        if (team) return team
        if (role) return role

        return "Destino não registrado"
    }

    const getAssignmentEligibleLabel = (assignment) => {
        const users = assignment?.eligible_users?.map(user => user.name).filter(Boolean) || []
        return users.length ? users.join(", ") : "-"
    }

    const periodStats = getSelectedPeriodStats()
    const selectedInboxes = getSelectedInboxes()
    const usdToBrlEstimate = Number(costEstimate?.exchange_rate?.rate || FALLBACK_USD_TO_BRL_ESTIMATE)
    const historicalProjection = getHistoricalCostProjection()
    const campaignProjection = getCampaignProjection()
    const estimatedTotal = historicalProjection.total + campaignProjection.total
    const activeTemplateMixPreset = getActiveTemplateMixPreset()

    return (
        <div className={styles.container}>
            <BackButton fallback={`/${account_id}/integrations/chat`} />
            <div className={styles.content}>
                <div className={styles.card}>
                    <div className={styles.header}>
                        <MdOutlineWhatsapp />
                        <span>WhatsApp</span>
                        {canAddWhatsAppInbox &&
                            <FormGroup>
                                <Button variant="primary" onClick={handleShowModalNewInbox}>
                                    Adicionar
                                </Button>
                            </FormGroup>
                        }
                    </div>
                    <div className={styles.body}>
                        <div className={styles.estimateCallout}>
                            <div className={styles.calloutIcon}>
                                <MdOutlineWhatsapp />
                            </div>
                            <div className={styles.calloutText}>
                                <div>
                                    <span>Simule a migração para WhatsApp API</span>
                                    <small>Novo</small>
                                </div>
                                <strong>Calcule sob demanda</strong>
                                <p>Entenda custos por caixa, janela de 24h, mix de templates e campanhas mensais.</p>
                            </div>
                            <div className={styles.calloutActions}>
                                <button className={styles.calloutInfoButton} onClick={() => setShowWhatsAppApiInfoModal(true)}>
                                    Entender WhatsApp API
                                </button>
                                <Button variant="secondary" onClick={handleShowCostEstimateModal}>
                                    Ver calculadora
                                </Button>
                            </div>
                        </div>
                        <FormGroup labelText="Caixas de Entrada">
                            {whatsAppInboxes.length > 0 && whatsAppInboxes.sort(sortWhatsAppInboxs).map((inbox) => {
                                const isSyncing = inbox?.sync?.status === "running"
                                const isCompleted = inbox?.sync?.status === "completed"
                                return (
                                    <InboxCard
                                        key={inbox._id}
                                        name={inbox.name}
                                        phone={maskPhone(inbox.phone)}
                                        status={inbox.status}
                                        platform="whatsapp"
                                        isSyncing={isSyncing}
                                        isCompleted={isCompleted}
                                        sync={inbox.sync}
                                        getProgressPercent={getProgressPercent}
                                        getElapsedTime={getElapsedTime}
                                        getSyncSpeed={getSyncSpeed}
                                        getEstimatedTime={getEstimatedTime}
                                        actions={[
                                            {
                                                label: "Configurar",
                                                onClick: () => handleShowModalInbox(inbox._id),
                                                alwaysVisible: true
                                            },
                                            {
                                                label: "Histórico de atribuição",
                                                onClick: () => handleShowAssignmentHistory(inbox),
                                                alwaysVisible: true
                                            },
                                            {
                                                label: "Sincronizar mensagens",
                                                onClick: () => handleShowModalSyncMessages(inbox),
                                                disabled: isSyncing
                                            },
                                            {
                                                label: "Sincronizar contatos",
                                                onClick: () => handleShowModalSyncContacts(inbox),
                                                disabled: isSyncing
                                            },
                                            { label: "QR Code de divulgação", onClick: () => setQrInbox(inbox) },
                                            ...(canAddWhatsAppInbox ? [{
                                                label: "Desconectar",
                                                type: "danger",
                                                onClick: () => handleShowModalDisconect(inbox),
                                                disabled: isSyncing
                                            }] : []),
                                            {
                                                label: inbox.status === "connected" ? "Ver conexão WhatsApp Lite" : "Conectar WhatsApp Lite",
                                                type: "primary",
                                                onClick: () => handleShowModalLiteConnection(inbox),
                                                alwaysVisible: true
                                            },
                                        ]}
                                    />
                                )
                            })}
                            {whatsAppInboxes.length === 0 && <span>Nenhuma caixa de entrada conectada até o momento!</span>}
                        </FormGroup>
                    </div>
                </div>
            </div>
            {canAddWhatsAppInbox && showModalNewInbox &&
                <ModalNewInbox
                    teams={teams}
                    users={users}
                    closeModal={handleCloseModalNewInbox}
                    onSubmit={handleSaveNewInbox}
                />
            }
            {qrInbox && <ModalWhatsAppQRCode inbox={qrInbox} closeModal={() => setQrInbox(null)} />}
            {canAddWhatsAppInbox && showModalDisconect &&
                <ModalConfirm
                    closeModal={handleCloseModalDisconect}
                    icon={<AiOutlineDisconnect />}
                    title="Deseja realmente desconectar a conta?"
                    description={`Ao desconectar a caixa de entrada ${inboxDisconect.name} você concorda com os detalhes abaixo`}
                    text="Após a desconexão, as mensagens enviadas a essa conta deixarão de ser direcionadas para nossa plataforma."
                    onSubmit={() => handleDisconectInbox(inboxDisconect)}
                />
            }
            {showModalSyncMessages &&
                <ModalConfirm
                    closeModal={handleCloseModalSyncMessages}
                    icon={<MdOutlineSync />}
                    title="Deseja sincronizar todas as mensagens?"
                    description={`Ao sincronizar a caixa de entrada ${ChatInboxSync.name}, todas as mensagens serão importadas para a Oktto conforme os detalhes abaixo`}
                    text="Serão sincronizadas todas as mensagens disponíveis nesta caixa de entrada, independentemente da data de envio ou recebimento."
                    onSubmit={() => handleSyncAllMessages(ChatInboxSync)}
                />
            }
            {showModalSyncContacts &&
                <ModalConfirm
                    closeModal={handleCloseModalSyncContacts}
                    icon={<MdOutlineSync />}
                    title="Deseja sincronizar todos os contatos?"
                    description={`Ao sincronizar a caixa de entrada ${ChatInboxSync.name}, todos os contatos serão importadas para a Oktto conforme os detalhes abaixo`}
                    text="Serão sincronizados todos os contatos disponíveis nesta caixa de entrada, independentemente da data de cadastro."
                    onSubmit={() => handleSyncAllContacts(ChatInboxSync)}
                />
            }
            {
                showModalInbox &&
                <ModalInbox
                    inbox={inbox}
                    teams={teams}
                    roles={roles}
                    users={users}
                    usersWithAuto={[{ id: "auto", value: "Rodízio Automático" }, ...users]}
                    chatBots={chatBots}
                    funnels={funnels}
                    closeModal={handleCloseModalInbox}
                    onSubmit={handleUpdateInbox}
                />
            }
            {showModalLiteConnection &&
                <ModalWhatsAppLiteConnection
                    inbox={liteConnectionInbox}
                    getQRCodeByConnect={getQRCodeByConnect}
                    closeModal={handleCloseModalLiteConnection}
                />
            }
            {showAssignmentHistoryModal &&
                <Modal
                    icon={<MdHistory />}
                    title="Histórico de atribuição"
                    description={`Caixa de entrada ${assignmentHistoryInbox?.name || ""}`}
                    closeModal={handleCloseAssignmentHistory}
                    fullWidith={true}
                    heightFitContent={true}
                >
                    <div className={styles.assignmentHistoryModal}>
                        <div className={styles.assignmentHistoryFilters}>
                            <DatePicker
                                multiple={true}
                                name="Período"
                                dateStart={assignmentHistoryFilters.dateStart || ""}
                                dateEnd={assignmentHistoryFilters.dateEnd || ""}
                                onChange={handleAssignmentHistoryPeriodChange}
                            />
                            <div className={styles.assignmentHistorySourceFilter}>
                                <div>
                                    <span>Origem</span>
                                    <InfoTooltip text={ASSIGNMENT_SOURCE_TOOLTIP} preferredPosition="bottom" />
                                </div>
                                <Select
                                    name="Todas as origens"
                                    placeholder="Todas as origens"
                                    options={ASSIGNMENT_SOURCE_OPTIONS}
                                    selected={assignmentHistoryFilters.sources || []}
                                    multiple={true}
                                    onChange={handleAssignmentHistorySourceChange}
                                />
                            </div>
                            <Button variant="secondary" onClick={() => getAssignmentHistory()}>
                                Filtrar
                            </Button>
                        </div>
                        <div className={styles.assignmentHistorySummary}>
                            <strong>{formatNumber(assignmentHistory?.pagination?.total || assignmentHistory?.assignments?.length || 0)}</strong>
                            <span>atribuições encontradas no período selecionado</span>
                        </div>
                        <div className={styles.assignmentHistoryTable}>
                            <div className={styles.assignmentHistoryHeader}>
                                <span>Data</span>
                                <span>Destino</span>
                                <span>Motivo</span>
                                <span>Regra</span>
                                <span>Elegíveis</span>
                                <span>Origem</span>
                                <span>Conversa</span>
                            </div>
                            {assignmentHistory?.assignments?.map(assignment => (
                                <div key={assignment._id} className={styles.assignmentHistoryRow}>
                                    <span>{formatDateTime(assignment.created_at)}</span>
                                    <strong>{getAssignmentTargetLabel(assignment)}</strong>
                                    <span>{getAssignmentReasonLabel(assignment)}</span>
                                    <span>{getAssignmentRuleLabel(assignment)}</span>
                                    <span>{getAssignmentEligibleLabel(assignment)}</span>
                                    <span>{getAssignmentSourceLabel(assignment.source)}</span>
                                    <span>
                                        {assignment?.conversation?.url ?
                                            <a href={`/${account_id}/chat/${assignment.conversation._id}`} target="_blank" rel="noreferrer">
                                                Abrir <MdOpenInNew />
                                            </a>
                                            : "-"
                                        }
                                    </span>
                                </div>
                            ))}
                            {!assignmentHistory?.assignments?.length && !isLoadingAssignmentHistory &&
                                <div className={styles.assignmentHistoryEmpty}>
                                    Nenhuma atribuição registrada nesse período.
                                </div>
                            }
                            {isLoadingAssignmentHistory &&
                                <div className={styles.assignmentHistoryEmpty}>
                                    Carregando histórico...
                                </div>
                            }
                        </div>
                        {assignmentHistory?.pagination?.has_more &&
                            <div className={styles.assignmentHistoryLoadMore}>
                                <Button variant="secondary" onClick={handleLoadMoreAssignmentHistory} disabled={isLoadingAssignmentHistory}>
                                    {isLoadingAssignmentHistory ? "Carregando..." : "Carregar mais"}
                                </Button>
                            </div>
                        }
                    </div>
                </Modal>
            }
            {showCostEstimateModal &&
                <Modal
                    icon={<MdOutlineWhatsapp />}
                    title="Estimativa para WhatsApp API"
                    description="Simule custos por caixa, janela de atendimento e campanhas mensais."
                    closeModal={() => setShowCostEstimateModal(false)}
                    fullWidith={true}
                    heightFitContent={true}
                >
                    <div className={styles.estimateModal}>
                        <CostEstimateStatus loading={isLoadingEstimate} error={estimateError} progress={estimateProgress} retry={refreshEstimate} />
                        {costEstimate && !isLoadingEstimate && !estimateError && <>
                        <div className={styles.filtersPanel}>
                            <div className={styles.filterHeader}>
                                <div>
                                    <strong>Filtros da estimativa</strong>
                                    <span>Escolha a base histórica. O custo é convertido para uma média mensal.</span>
                                </div>
                                <button onClick={getOfficialApiCostEstimate} disabled={isLoadingEstimate}>
                                    Atualizar histórico
                                </button>
                            </div>
                            <div className={styles.filtersGrid}>
                                <label>
                                    <span>
                                        Período
                                        <InfoTooltip text="A calculadora usa as mensagens já sincronizadas na Oktto dentro do período selecionado." />
                                    </span>
                                    <div className={styles.periodTabs}>
                                        {[30, 60, 90].map(period => (
                                            <button
                                                key={period}
                                                className={Number(selectedPeriod) === period ? styles.activePeriod : ""}
                                                onClick={() => setSelectedPeriod(period)}
                                            >
                                                {period} dias
                                            </button>
                                        ))}
                                    </div>
                                </label>
                                <label>
                                    <span>
                                        Caixas de entrada
                                        <InfoTooltip text="Selecione uma ou mais caixas para estimar o custo individual ou somado. O resumo por caixa aparece quando houver mais de uma selecionada." />
                                    </span>
                                    <Select
                                        name="Caixas de entrada"
                                        placeholder="Buscar caixa"
                                        multiple={true}
                                        options={(costEstimate?.inboxes || []).map(inbox => ({
                                            id: inbox._id?.toString(),
                                            value: inbox.name,
                                        }))}
                                        selected={selectedInboxIds}
                                        emptyName="Nenhuma caixa selecionada"
                                        onChange={setSelectedInboxIds}
                                    />
                                </label>
                            </div>
                        </div>
                        <CostEstimateStatus
                            stats={periodStats}
                            periodDays={selectedPeriod}
                            noInboxSelected={costEstimate.inboxes.length > 0 && getSelectedInboxes().length === 0}
                        />
                        <div className={styles.estimateIntro}>
                            <div>
                                <strong>{formatMoney(estimatedTotal)}</strong>
                                <span>Custo mensal estimado com média do histórico selecionado e disparos simulados.</span>
                            </div>
                            <div>
                                <small>Taxas em dólar</small>
                                <span>A Meta publica as taxas em USD. Esta calculadora converte para real usando US$ 1 = {formatMoney(usdToBrlEstimate)} ({costEstimate?.exchange_rate?.source_name || "fallback interno"}).</span>
                                <a href={WHATSAPP_API_PRICING_URL} target="_blank" rel="noreferrer">Conferir taxas atualizadas no WhatsApp</a>
                            </div>
                        </div>
                        <div className={styles.pricingNotice}>
                            <span>Valores usados:</span>
                            {TEMPLATE_CATEGORIES.map(category => (
                                <strong key={category.id}>{category.value}: {formatUsd(WHATSAPP_API_RATES_USD[category.id])}</strong>
                            ))}
                            <strong>Serviço: {formatUsd(WHATSAPP_API_RATES_USD.service)}</strong>
                        </div>
                        <div className={styles.metricGrid}>
                            <div>
                                <span>Mensagens enviadas</span>
                                <strong>{formatNumber(periodStats.sent_messages)}</strong>
                            </div>
                            <div>
                                <span>Dentro da janela 24h <InfoTooltip text="Mensagens enviadas até 24h depois de uma mensagem recebida são tratadas como atendimento, sem custo de serviço na API." /></span>
                                <strong>{formatNumber(periodStats.sent_inside_24h_window)}</strong>
                            </div>
                            <div>
                                <span>Iniciadas pela empresa <InfoTooltip text="Envios sem mensagem recebida anterior na janela de 24h. Na WhatsApp API, esses envios normalmente usam templates pagos." /></span>
                                <strong>{formatNumber(periodStats.sent_outside_24h_window)}</strong>
                            </div>
                            <div>
                                <span>Contatos únicos</span>
                                <strong>{formatNumber(periodStats.unique_contacts)}</strong>
                            </div>
                        </div>
                        <div className={styles.monthlyAverageNote}>
                            <span>Base financeira mensal:</span>
                            <strong>{formatNumber(historicalProjection.paidMessages)} envios pagos estimados/mês</strong>
                            <small>Calculado proporcionalmente a partir dos {selectedPeriod} dias selecionados.</small>
                        </div>
                        <div className={styles.calculatorGrid}>
                            <div className={styles.panel}>
                                <div className={styles.panelHeader}>
                                    <strong>
                                        Mix dos templates
                                        <InfoTooltip text="Use uma predefinição ou ajuste os percentuais. Quando uma categoria muda, as outras são recalculadas para o total permanecer em 100%." />
                                    </strong>
                                    <span>Distribua os envios pagos entre categorias. Taxa média: {formatUsd(getAverageTemplateRateUsd())} · aprox. {formatMoney(getAverageTemplateRate())}.</span>
                                </div>
                                <div className={styles.mixPresets}>
                                    <button className={activeTemplateMixPreset === "balanced" ? styles.activePreset : ""} onClick={() => applyTemplateMixPreset("balanced")}>Equilibrado</button>
                                    <button className={activeTemplateMixPreset === "marketing" ? styles.activePreset : ""} onClick={() => applyTemplateMixPreset("marketing")}>Mais marketing</button>
                                    <button className={activeTemplateMixPreset === "utility" ? styles.activePreset : ""} onClick={() => applyTemplateMixPreset("utility")}>Mais utilidade</button>
                                    <button className={activeTemplateMixPreset === "service" ? styles.activePreset : ""} onClick={() => applyTemplateMixPreset("service")}>Atendimento</button>
                                    <button className={activeTemplateMixPreset === "lowMarketing" ? styles.activePreset : ""} onClick={() => applyTemplateMixPreset("lowMarketing")}>Pouco marketing</button>
                                    <button className={activeTemplateMixPreset === "authentication" ? styles.activePreset : ""} onClick={() => applyTemplateMixPreset("authentication")}>Com autenticação</button>
                                </div>
                                <div className={styles.mixRows}>
                                    {TEMPLATE_CATEGORIES.map(category => (
                                        <label key={category.id}>
                                            <span>{category.value}</span>
                                            <div className={styles.mixBar}>
                                                <div style={{ width: `${templateMix[category.id]}%` }} />
                                            </div>
                                            <div className={styles.percentInput}>
                                                <Input type="number" value={templateMix[category.id]} onChange={(e) => handleTemplateMixChange(category.id, e.target.value)} />
                                                <span>%</span>
                                            </div>
                                            <small>{formatUsd(WHATSAPP_API_RATES_USD[category.id])} · {formatMoney(getRateBrl(category.id, usdToBrlEstimate))}</small>
                                        </label>
                                    ))}
                                </div>
                                <div className={styles.mixTotal}>
                                    <span>Total informado: {formatNumber(getTemplateMixTotal())}%</span>
                                    <strong>Distribuição sempre fechada em 100%</strong>
                                </div>
                                <div className={styles.costBreakdown}>
                                    {TEMPLATE_CATEGORIES.map(category => (
                                        <div key={category.id}>
                                            <span>{category.value}</span>
                                            <strong>{formatNumber(historicalProjection.messagesByCategory[category.id])}</strong>
                                            <small>{formatMoney(historicalProjection.costByCategory[category.id])}</small>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className={styles.panel}>
                                <div className={styles.panelHeader}>
                                    <strong>
                                        Simular disparos
                                        <InfoTooltip text="Informe quantos contatos receberiam cada tipo de template e quantas vezes isso aconteceria no mês. Cada categoria é cobrada pelo seu próprio valor." />
                                    </strong>
                                    <span>Projete campanhas mensais por categoria de template.</span>
                                </div>
                                <div className={styles.campaignRows}>
                                    {TEMPLATE_CATEGORIES.map(category => {
                                        const simulation = campaignSimulation[category.id] || {}
                                        const projection = campaignProjection.byCategory.find(item => item.category === category.id)

                                        return (
                                            <div key={category.id} className={styles.campaignRow}>
                                                <div>
                                                    <strong>{category.value}</strong>
                                                    <span>{formatUsd(WHATSAPP_API_RATES_USD[category.id])} · aprox. {formatMoney(getRateBrl(category.id, usdToBrlEstimate))}</span>
                                                </div>
                                                <label>
                                                    <span>Contatos</span>
                                                    <Input type="number" value={simulation.contacts} onChange={(e) => handleCampaignSimulationChange(category.id, "contacts", e.target.value)} />
                                                </label>
                                                <label>
                                                    <span>Disparos/mês</span>
                                                    <Input type="number" value={simulation.campaigns} onChange={(e) => handleCampaignSimulationChange(category.id, "campaigns", e.target.value)} />
                                                </label>
                                                <div>
                                                    <span>{formatNumber(projection?.messages)} mensagens</span>
                                                    <strong>{formatMoney(projection?.total)}</strong>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                                <div className={styles.campaignTotal}>
                                    <span>{formatNumber(campaignProjection.messages)} mensagens simuladas no mês</span>
                                    <strong>{formatMoney(campaignProjection.total)}</strong>
                                </div>
                            </div>
                        </div>
                        <div className={styles.estimateFooter}>
                            <div>
                                <span>Histórico médio mensal</span>
                                <strong>{formatMoney(historicalProjection.total)}</strong>
                            </div>
                            <div>
                                <span>Disparos simulados no mês</span>
                                <strong>{formatMoney(campaignProjection.total)}</strong>
                            </div>
                            <div>
                                <span>Total mensal estimado</span>
                                <strong>{formatMoney(estimatedTotal)}</strong>
                            </div>
                        </div>
                        {selectedInboxes.length > 1 &&
                            <div className={styles.inboxSummary}>
                                <div className={styles.panelHeader}>
                                    <strong>Resumo por caixa</strong>
                                    <span>Custo histórico médio mensal, sem distribuir os disparos simulados.</span>
                                </div>
                                <div className={styles.inboxSummaryRows}>
                                    {selectedInboxes.map(inbox => {
                                        const stats = getPeriodStatsFromInbox(inbox)
                                        const projection = getInboxHistoricalProjection(inbox)

                                        return (
                                            <div key={inbox._id}>
                                                <span>{inbox.name}</span>
                                                <strong>{formatMoney(projection.total)}</strong>
                                                <small>{formatNumber(stats.sent_messages)} enviadas · {formatNumber(projection.paidMessages)} pagas</small>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        }
                        </>}
                    </div>
                </Modal>
            }
            {showWhatsAppApiInfoModal &&
                <Modal
                    icon={<MdOutlineWhatsapp />}
                    title="Guia simples da WhatsApp API"
                    description="Uma cartilha para entender a migração, custos, campanhas, templates e cuidados."
                    closeModal={() => setShowWhatsAppApiInfoModal(false)}
                    fullWidith={true}
                    heightFitContent={true}
                >
                    <div className={styles.apiInfoModal}>
                        <section className={styles.apiInfoHero}>
                            <div>
                                <span>Cartilha</span>
                                <h3>WhatsApp API em linguagem simples</h3>
                                <p>
                                    A WhatsApp API é uma forma mais profissional de usar um número do WhatsApp dentro da Oktto. Ela foi criada para empresas que precisam atender em equipe, organizar conversas e fazer campanhas com mais controle.
                                </p>
                            </div>
                            <div className={styles.apiInfoHeroCards}>
                                <div>
                                    <strong>WhatsApp Lite</strong>
                                    <p>Funciona mais parecido com um WhatsApp conectado. É simples, mas pode ser mais sensível para volume alto, campanhas e instabilidade do número.</p>
                                </div>
                                <div>
                                    <strong>WhatsApp API</strong>
                                    <p>O número vira um canal empresarial integrado. O atendimento acontece na Oktto, com templates, custos por categoria e regras mais claras da Meta.</p>
                                </div>
                            </div>
                        </section>
                        <div className={styles.apiInfoHighlights}>
                            <div>
                                <span>01</span>
                                <strong>Mais segurança operacional</strong>
                                <p>Menos dependência de celular conectado e menos fragilidade em operações com muitos atendentes.</p>
                            </div>
                            <div>
                                <span>02</span>
                                <strong>Campanhas organizadas</strong>
                                <p>Disparos em massa passam a usar templates aprovados, categorias e acompanhamento de qualidade.</p>
                            </div>
                            <div>
                                <span>03</span>
                                <strong>Custos previsíveis</strong>
                                <p>Você consegue estimar quanto custa iniciar conversas, separar categorias e planejar campanhas.</p>
                            </div>
                            <div>
                                <span>04</span>
                                <strong>Atendimento pela Oktto</strong>
                                <p>Depois da migração, a equipe atende pela Oktto. O número não fica operando no app comum.</p>
                            </div>
                        </div>
                        <section>
                            <h4>Banimento de número: o que muda?</h4>
                            <p>
                                Banimento é quando o WhatsApp restringe ou bloqueia um número por entender que ele está gerando risco, spam ou experiência ruim para os usuários. No Lite, isso costuma ser mais sensível quando há muitos envios, muitas conversas novas, mensagens repetidas ou reclamações.
                            </p>
                            <p>
                                Na WhatsApp API, o risco não desaparece, mas funciona de outra forma: a Meta trabalha com templates aprovados, limites de envio, avaliação de qualidade e categorias de mensagem. Isso torna a operação mais profissional e previsível para campanhas e grandes volumes.
                            </p>
                        </section>
                        <section>
                            <h4>O que são templates?</h4>
                            <p>
                                Template é um modelo de mensagem aprovado pela Meta para iniciar uma conversa ou falar com o cliente fora da janela de atendimento. Exemplo: aviso de promoção, confirmação de pedido, lembrete de consulta ou código de autenticação.
                            </p>
                            <div className={styles.templateExamples}>
                                <div>
                                    <strong>Marketing</strong>
                                    <p>“Olá, {"{{nome}}"}. Temos uma condição especial para você esta semana.”</p>
                                </div>
                                <div>
                                    <strong>Utilidade</strong>
                                    <p>“Seu pedido {"{{codigo}}"} foi enviado. Acompanhe pelo link: {"{{link}}"}.”</p>
                                </div>
                                <div>
                                    <strong>Autenticação</strong>
                                    <p>“Seu código de verificação é {"{{codigo}}"}. Ele expira em 10 minutos.”</p>
                                </div>
                            </div>
                            <p>
                                As partes entre chaves são variáveis. A Oktto substitui esses campos pelos dados do cliente, pedido, agendamento ou campanha.
                            </p>
                        </section>
                        <section>
                            <h4>Como funcionam campanhas e disparos?</h4>
                            <p>
                                Campanha é o envio de uma mensagem para muitos contatos. Na API, esse envio deve usar template aprovado e respeitar boas práticas: contatos com permissão para receber mensagens, texto relevante, frequência controlada e acompanhamento de bloqueios/respostas.
                            </p>
                            <p>
                                A vantagem é que campanhas deixam de ser um “envio improvisado” e passam a ter regra, categoria, custo estimado e controle operacional.
                            </p>
                        </section>
                        <section className={styles.migrationSection}>
                            <h4>Processo de migração, passo a passo</h4>
                            <div className={styles.migrationTimeline}>
                                <div>
                                    <span>1</span>
                                    <strong>Diagnóstico</strong>
                                    <p>Entender volume atual, quantidade de atendentes, campanhas, risco de banimento e custo provável com a calculadora.</p>
                                </div>
                                <div>
                                    <span>2</span>
                                    <strong>Preparação da empresa</strong>
                                    <p>Validar dados da empresa, acesso ao Gerenciador da Meta, permissões e estrutura necessária para conectar o número.</p>
                                </div>
                                <div>
                                    <span>3</span>
                                    <strong>Escolha do número</strong>
                                    <p>Definir se será migrado o número atual ou um novo número. O número da API deixa de ser usado no aplicativo comum.</p>
                                </div>
                                <div>
                                    <span>4</span>
                                    <strong>Conexão na Oktto</strong>
                                    <p>Conectar a conta WhatsApp API, configurar caixa de entrada, usuários, filas e regras de atendimento.</p>
                                </div>
                                <div>
                                    <span>5</span>
                                    <strong>Criação dos templates</strong>
                                    <p>Cadastrar mensagens para marketing, utilidade ou autenticação. A Meta aprova antes de usar para iniciar conversas.</p>
                                </div>
                                <div>
                                    <span>6</span>
                                    <strong>Virada operacional</strong>
                                    <p>Orientar a equipe: as conversas passam a ser atendidas pela Oktto. Testar recebimento, envio, templates e rotina de atendimento.</p>
                                </div>
                                <div>
                                    <span>7</span>
                                    <strong>Acompanhamento</strong>
                                    <p>Monitorar custos, respostas, bloqueios, qualidade do número e performance das campanhas nos primeiros dias.</p>
                                </div>
                            </div>
                        </section>
                        <div className={styles.apiInfoGrid}>
                            <section>
                                <h4>Quando costuma fazer sentido?</h4>
                                <ul>
                                    <li>Quando há muitos atendentes usando o mesmo número.</li>
                                    <li>Quando campanhas e disparos fazem parte da estratégia comercial.</li>
                                    <li>Quando o número Lite sofre quedas, bloqueios ou instabilidade.</li>
                                    <li>Quando a operação precisa de mais previsibilidade, controle e histórico centralizado.</li>
                                </ul>
                            </section>
                            <section>
                                <h4>O que precisa combinar antes?</h4>
                                <ul>
                                    <li>Quem vai atender somente pela Oktto depois da migração.</li>
                                    <li>Quais templates são necessários para começar.</li>
                                    <li>Qual volume mensal de campanhas será permitido.</li>
                                    <li>Como serão medidos custo, resposta, bloqueios e qualidade.</li>
                                </ul>
                            </section>
                        </div>
                        <section>
                            <h4>Como ler esta calculadora</h4>
                            <p>
                                A estimativa usa o histórico sincronizado na Oktto para separar respostas dentro da janela de atendimento de 24h e envios que provavelmente precisariam de template. Depois você ajusta o mix de templates e simula campanhas para entender o impacto mensal.
                            </p>
                            <p>
                                Ela não decide sozinha se você deve migrar. Ela ajuda a enxergar o custo provável e comparar com os ganhos de escala, segurança operacional, atendimento centralizado e campanhas.
                            </p>
                            <a href={WHATSAPP_API_PRICING_URL} target="_blank" rel="noreferrer">Ver taxas oficiais no site do WhatsApp</a>
                        </section>
                    </div>
                </Modal>
            }
            {isLoading && <Loading fullPage={true} />}
        </div>
    )
}

export default WhatsAppIntegration
